module.exports = __webpack_public_path__ + "b550028f46c482a75dd72798f08a7546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msh22.png
// module id = 98
// module chunks = 1